import {FaqCategory} from '../../../models/api';

export default [
  {
    name: 'Категория вопросов 1',
    questions: [
      {
        id: 1,
        name: 'Какие документы необходимы для оформления ЕСК?',
        answer: undefined,
        answers: [
          '-документ, удостоверяющий личность (паспорт гражданина РФ/ удостоверение военнослужащего/ военный билет)',
          '-страховое свидетельство обязательного пенсионного страхования (СНИЛС)',
          '+ по желанию:',
          '-полис обязательного медицинского страхования',
          '-свидетельство ИНН',
        ],
        answerMarkdown: undefined,
      },
      {
        id: 5,
        name: 'Что такое ЕСК?',
        answer:
          'Единая социальная карта Свердловской области - это многофункциональная пластиковая карта с электронным носителем, Ваш уникальный ключ к различным видам повседневных услуг.\nС помощью ЕСК жители Свердловской области могут:',
        answers: [
          'оплатить товары и услуги',
          'проезд в общественном транспорте',
          'получать социальные выплаты',
          'пользоваться скидками и бонусами от партнеров проекта',
          'оплатить проезд',
        ],
        answerMarkdown: undefined,
      },
    ],
  },
  {
    name: 'Категория вопросов 2',
    questions: [
      {
        id: 8,
        name: 'Где можно получить Единую социальную карту?',
        answer: undefined,
        answers: undefined,
        answerMarkdown:
          'Получить Единую социальную карту и пользоваться всеми ее сервисами может каждый житель Свердловской области, достигший 14 лет. Карта оформляется и обслуживается бесплатно на протяжении всего срока действия.\nБанковскую ЕСК можно будет оформить в отделениях СКБ-банка, нефинансовую - в сервисных центрах ЕКАРТЫ. В течение 15 минут вы получите готовую карту и сразу же сможете начать пользоваться всеми ее преимуществами.\n**На сегодняшний день карта с расчетным приложением выдается в отделениях СКБ-банка на всей территории Свердловской области. С развитием проекта количество банков-соэмитентов, оформляющих ЕСК, будет увеличиваться.**',
      },
      {
        id: 16,
        name: 'Будет ли карта персонифицирована?',
        answerMarkdown:
          'На текущий момент ЕСК не имеет визуальной персонификации, вся информация о владельце карты надежно хранится в облачном сервисе.',
      },
    ],
  },
] as FaqCategory[];
